// extracted by mini-css-extract-plugin
module.exports = {"badge":"profile-image-skins-xsmallOnWide-badge-c44eb73a"};